module.exports = __webpack_public_path__ + "img/img03.44791bde.png";